/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { AuthService } from './@core/services/auth.service';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import * as LogRocket from 'logrocket';
import { environment } from '../environments/environment';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
  providers: [Title]
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService, private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute,
    private ttile: Title) {
      if(!window.location.href.includes('report')) {
        this.authService.runInitialLoginSequence();
      }
  }

  ngOnInit(): void {
    // if(environment.enableLogrocket) {
    //   LogRocket.init('s9acf7/idraft-dev');
    // }

    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.ttile.setTitle(data.title)
      });
    });

  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }


}
